module.exports = __webpack_public_path__ + "img/pig_animal_4443_reverse.5c690786.png";